import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ForSaleComponentInner } from './ForSaleComponentInner';

const basename = '/till-salu/';

interface Props {
  stickyTitle?: string;
  stickyText?: string;
}

const ForSaleComponent = ({ stickyTitle, stickyText }: Props): JSX.Element => {
  const path = `/:estateType?/:county?/:muni?/:area?`;

  return (
    <Router basename={basename}>
      <Routes>
        <Route
          path={path}
          element={
            <div className="relative">
              <ForSaleComponentInner
                stickyTitle={stickyTitle}
                stickyText={stickyText}
              />
            </div>
          }
        />
      </Routes>
    </Router>
  );
};
export default ForSaleComponent;
